/**
 * Radiologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: IMAG
 * Catalogue acts (NGAP Maroc): 50
 */
import { defineSpecialty } from "../types";

export const radiologie = defineSpecialty(
{
  "id": "radiologie",
  "label": "Radiologie",
  "short": "Radiologie",
  "scope": "Imagerie médicale",
  "aliases": [
    "IMAG"
  ],
  "doctorSpecs": [
    "Radiologie"
  ],
  "featureFlag": "ux.v2.radiologie",
  "theme": {
    "primary": "oklch(0.60 0.12 250)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.80 0.15 90)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "worklist",
      "label": "Worklist",
      "icon": "ListChecks",
      "route": "/clinical/worklist",
      "order": 1,
      "requires": [
        "pacs"
      ]
    },
    {
      "id": "viewer",
      "label": "Visionneuse",
      "icon": "Image",
      "route": "/clinical/viewer",
      "order": 2,
      "requires": [
        "pacs"
      ]
    },
    {
      "id": "reporting",
      "label": "Compte-rendu",
      "icon": "FileText",
      "route": "/clinical/reporting",
      "order": 3,
      "requires": []
    },
    {
      "id": "ai",
      "label": "Aide IA",
      "icon": "Sparkles",
      "route": "/clinical/ai",
      "order": 4,
      "requires": [
        "ai"
      ]
    }
  ],
  "panels": [
    {
      "id": "viewer",
      "label": "Visionneuse",
      "icon": "Image",
      "component": "DicomViewer",
      "order": 1,
      "requires": []
    },
    {
      "id": "series",
      "label": "Séries",
      "icon": "Layers",
      "component": "SeriesNavigator",
      "order": 2,
      "requires": []
    },
    {
      "id": "ai",
      "label": "Suggestions IA",
      "icon": "Sparkles",
      "component": "AiSuggestionPanel",
      "order": 3,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Radiologie",
    "subSpecialties": [
      "Radiographie",
      "Scanner",
      "IRM",
      "Échographie",
      "Scintigraphie"
    ],
    "catalogueActs": 50
  },
  "terminology": {
    "icd10": [
      "R00",
      "R10",
      "R50"
    ],
    "loinc": [
      "24627-2",
      "16874-8"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "xray-digital",
    "ct-scanner",
    "mri-scanner",
    "ultrasound-general",
    "dicom-workstation"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default radiologie;
